export const searchCardInputs = [
    {
        label: "승인",
        key: "approvalPhase",
        type: "auto",
        col: "12",
        sm: "4",
        lg: "4",
        value: "All",
        list: ["All", "미확인", "미승인", "승인", "반려"],
    },
    {
        label: "프로젝트 코드",
        key: "projectCode",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
    },
    {
        label: "사내 견적번호",
        key: "inhouseBidNumber",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
    },
    {
        label: "기업별 입찰번호",
        key: "companyBidNumber",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
    },
    {
        label: "업체명",
        key: "companyName",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
    },
    {
        label: "발행일",
        key: "issueDate",
        type: "dateRange",
        range: true,
        value: [],
        col: "12",
        sm: "4",
        lg: "8",
    },
];
export const search_estimate_headers = [
    { text: "단계", align: "center", value: "approvalPhase" },
    { text: "발행일", align: "center", value: "createdTime" },
    { text: "작성자", align: "center", value: "createrName" },
    { text: "업체명", align: "center", value: "companyName" },
    { text: "프로젝트 코드", align: "center", value: "projectCode" },
    { text: "사내 견적번호", align: "center", value: "inhouseBidNumber" },
    { text: "기업별 입찰번호", align: "center", value: "companyBidNumber" },
    { text: "총액", align: "center", value: "totalPrice" },
];
